import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["colorSet", "className", "theme"];
import React from 'react';
import { spacer8, spacer12 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { renamedPropWarning } from "../../deprecationWarnings";
import { useEncoreContextType } from "../../hooks/useEncoreContextType";
import { addColorSet, defaultColorSet, overlay, rootStyle, typeStyleBody2, viola } from "../../styles";
var TooltipWrapper = styled.div.withConfig({
  displayName: "Tooltip__TooltipWrapper",
  componentId: "muq3yw-0"
})(["", ";", ";", ";padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";text-transform:initial;color:var(--text-base,", ");overflow-wrap:break-word;"], rootStyle(), overlay({
  maxWidth: '240px'
}), function () {
  return useEncoreContextType(typeStyleBody2(), viola());
}, spacer8, spacer8, spacer12, spacer12, defaultColorSet.text.base);
export var Tooltip = /*#__PURE__*/React.forwardRef(function Tooltip(_ref, ref) {
  var _ref$colorSet = _ref.colorSet,
      colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
      className = _ref.className,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  if (theme) {
    renamedPropWarning('theme', 'colorSet');
  }

  return /*#__PURE__*/React.createElement(TooltipWrapper, Object.assign({
    ref: ref,
    className: addColorSet(colorSet, className),
    role: "tooltip"
  }, props));
});
/**
* **Tooltip** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Tooltip) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-tooltip--default) | [Encore](https://encore.spotify.net/web/components/tooltip) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=0:1544) |
*
* The Tooltip displays a text label when users hover over or focus on an element.
*
* @example
* () => (
*  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*);
*
*/

export default Tooltip;